import { Button } from '@mui/material';
import { MdPrint } from '@teamworksdev/icons';
import { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { useViewer } from '../../../context/viewer';

interface ExportHeaderProps {
  onClick: () => void;
  /**
   * Lets the block page reclaim focus for this trigger after "Stop
   * Displaying" unmounts the badge the drawer was opened from.
   */
  buttonRef?: Ref<HTMLButtonElement>;
}

// The Export drawer itself is owned by the block page (BlockContent) - the
// badge in DisplayedWorkoutBadge.tsx opens the same drawer instance to the
// Digital Display tab, so both triggers need a single shared open/tab state.
export const ExportHeader = ({ onClick, buttonRef }: ExportHeaderProps) => {
  const { t } = useTranslation();
  const {
    org: { hasDigitalDisplays },
  } = useViewer();

  if (!hasDigitalDisplays) {
    return (
      <Button
        ref={buttonRef}
        onClick={onClick}
        variant="outlined"
        aria-label={t('print')}
      >
        <MdPrint size={18} aria-hidden="true" />
      </Button>
    );
  }

  return (
    <Button ref={buttonRef} onClick={onClick} variant="outlined">
      {t('export')}
    </Button>
  );
};
